/**
 * The text a patient gets right after the agent books a visit. The API sends a fixed message
 * today; these tokens and the default below mirror it word for word, so a practice that never
 * edits it keeps getting exactly what it gets now.
 */

export type ConfirmationToken = { key: string; label: string; sample: string }

export const CONFIRMATION_TOKENS: ConfirmationToken[] = [
  { key: `contact.firstName`, label: `First name`, sample: `Mark` },
  { key: `location.name`, label: `Practice name`, sample: `` },
  { key: `appointment.day`, label: `Day`, sample: `Monday` },
  { key: `appointment.date`, label: `Date`, sample: `January 15` },
  { key: `appointment.time`, label: `Time`, sample: `3:30 PM` },
  { key: `location.phone`, label: `Office phone`, sample: `` },
]

export const DEFAULT_CONFIRMATION_MESSAGE = `{{contact.firstName}}, your appointment at {{location.name}} is confirmed for {{appointment.day}}, {{appointment.date}} at {{appointment.time}}. Questions? Call {{location.phone}}.`

/** Always added to the end of the text, so every confirmation keeps its opt-out. */
export const OPT_OUT_SUFFIX = `Reply STOP to opt out.`

/**
 * The message as a patient would read it, with sample values for the patient and visit and the
 * practice's own name and phone, opt-out included.
 */
export function renderConfirmationSample(body: string, practice: { name: string; phone?: string }): string {
  const samples: Record<string, string> = {
    ...Object.fromEntries(CONFIRMATION_TOKENS.map((token) => [token.key, token.sample])),
    'location.name': practice.name,
    'location.phone': practice.phone || `(555) 555-5555`,
  }
  const filled = body.trim().replace(/\{\{\s*([\w.]+)\s*\}\}/g, (whole, key: string) => samples[key] ?? whole)
  return filled ? `${filled} ${OPT_OUT_SUFFIX}` : OPT_OUT_SUFFIX
}
